<mat-progress-bar mode="indeterminate" *ngIf="loader?.value$ | async"></mat-progress-bar>
<app-offline-bar [isLogged]="loggedIn$ | async"></app-offline-bar>
<app-update-bar></app-update-bar>
<router-outlet></router-outlet>
